import type { SxProps, Theme } from '@mui/material';

export const checkboxControlRootSx: SxProps<Theme> = (theme) => ({
  display: 'flex',
  '& .MuiCheckbox-root': {
    zIndex: 0,
    '&.Mui-checked .MuiIconButton-label:after': {
      content: '""',
      top: '31%',
      left: '32%',
      width: '35%',
      height: '39%',
      position: 'absolute',
      backgroundColor: theme.palette.primary.contrastText,
      zIndex: -1,
      borderColor: 'transparent',
    },
  },
  '& .MuiTypography-root': {
    userSelect: 'none',
  },
});
